import React from 'react';
import { ThemeContextProvider } from '@qler-view/shared_lib/src/shared/lib/providers/ThemeProviderContext.tsx';
import { clinicalLightTheme, clinicalDarkTheme } from '../utils/clinicalTheme';
import type { ReactNode } from 'react';

interface ClinicalThemeProviderProps {
  children: ReactNode;
}

export const ClinicalThemeProvider: React.FC<ClinicalThemeProviderProps> = ({
  children,
}) => {
  return (
    <ThemeContextProvider
      lightTheme={clinicalLightTheme}
      darkTheme={clinicalDarkTheme}
    >
      {children}
    </ThemeContextProvider>
  );
};
